import { Card, Row, Col } from 'antd';
import { DetailRow, PaymentStatusRow } from './DetailRow';

/**
 * OrderInfoCard - Displays primary order, patient and appointment information
 */
const OrderInfoCard = ({ order, hasPatientDetails, hasAppointmentDetails }) => {
    return (
        <Card
            className="mb-3"
            headStyle={{
                background: '#1890ff',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                padding: '16px 24px',
            }}
            bodyStyle={{ padding: '24px' }}
            bordered={false}
            title={<span style={{ color: '#fff', fontSize: '18px', fontWeight: '600' }}>Order Summary</span>}
        >
            {/* Order Details Section */}
            <div className="mb-4">
                <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#262626' }}>
                    Order Details
                </h6>
                <Row gutter={[24, 0]}>
                    <Col xs={24} md={12}>
                        <DetailRow icon="hash" label="Order ID" value={order?.orderUniqueId} />
                        <DetailRow
                            icon="shopping-cart"
                            label="Order Status"
                            value={order?.orderStatus}
                            hasCheckIcon={order?.orderStatus === 'Completed'}
                        />
                        <DetailRow
                            icon="user-check"
                            label="Created By"
                            value={order?.createdByName || order?.additionalInfo?.createdByName || '---'}
                        />
                        <DetailRow
                            icon="user-check"
                            label="Collected By"
                            value={order?.updatedByName || '---'}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <PaymentStatusRow
                            icon="check-circle"
                            label="Order Status"
                            value={order?.orderStatus}
                            hasCheckIcon={true}
                        />
                        <PaymentStatusRow
                            icon="check-circle"
                            label="Payment Status"
                            value={order?.paymentStatus && order?.paymentMode ? `${order.paymentStatus} (${order.paymentMode})` : null}
                            hasCheckIcon={order?.paymentStatus === 'Completed'}
                        />
                    </Col>
                </Row>
            </div>

            {/* Patient Details Section */}
            {hasPatientDetails && (
                <div className="mb-4">
                    <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#262626' }}>
                        Patient Details
                    </h6>
                    <Row gutter={[24, 0]}>
                        <Col xs={24} md={12}>
                            <DetailRow
                                icon="user"
                                label="Name"
                                value={order?.additionalInfo?.customerName || order?.additionalInfo?.name}
                            />
                            <DetailRow icon="users" label="Gender" value={order?.customerId?.gender} />
                        </Col>
                        <Col xs={24} md={12}>
                            <DetailRow icon="phone" label="Phone" value={order?.additionalInfo?.phoneNo} />
                            <DetailRow icon="mail" label="Email" value={order?.additionalInfo?.email} />
                        </Col>
                    </Row>
                </div>
            )}

            {/* Appointment Details Section */}
            {hasAppointmentDetails && (
                <div className="mb-4">
                    <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#262626' }}>
                        Appointment Details
                    </h6>
                    <DetailRow
                        icon="activity"
                        label="Service"
                        value={
                            order?.additionalInfo?.treatment ||
                            order?.additionalInfo?.treatmentData?.map(t => t.treatmentName).join(', ') ||
                            order?.additionalInfo?.solutionData?.map(s => s.solutionName).join(', ') ||
                            order?.additionalInfo?.serviceData?.map(svc => svc.name).join(', ') ||
                            order?.additionalInfo?.detoxRetreatData?.map(d => d.detoxRetreatName).join(', ')
                        }
                    />
                    <DetailRow
                        icon="video"
                        label="Consultation Type"
                        value={
                            order?.additionalInfo?.consultationType ||
                            (order?.additionalInfo?.totalDays ? `${order?.additionalInfo?.totalDays} Days` : null)
                        }
                    />
                    <DetailRow
                        icon="calendar"
                        label="Date & Time"
                        value={
                            order?.additionalInfo?.startTime && order?.additionalInfo?.endTime
                                ? `${order?.additionalInfo?.date || order?.additionalInfo?.bookingDate} | ${order?.additionalInfo?.startTime} – ${order?.additionalInfo?.endTime}`
                                : order?.additionalInfo?.startDate && order?.additionalInfo?.endDate
                                    ? `${order?.additionalInfo?.startDate} – ${order?.additionalInfo?.endDate}`
                                    : null
                        }
                    />
                </div>
            )}
        </Card>
    );
};

export default OrderInfoCard;
